const ActionTypes = {
  SET_SS_VISIBILITY: 'SET_SS_VISIBILITY'
};

function setSSVisibility (payload = null) {
  return {
    type: ActionTypes.SET_SS_VISIBILITY,
    payload
  };
}

export {
  setSSVisibility,
  ActionTypes
};



// WEBPACK FOOTER //
// ./src/js/store/actions/splashScreen.js